import React, { useState, useEffect } from 'react'
import SearchIcon from '@mui/icons-material/Search';
import "./navbar.scss";
import { Sidebar } from '../sidebar/sidebar.jsx';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MessageIcon from '@mui/icons-material/Message';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import { Notifications } from '../../modals/notificationsModal.jsx';
import { Messages } from '../../modals/messagesModal.jsx';
import { AccountModal } from '../../modals/accountModal.jsx';
import { fetchAuthSession, updatePassword, resetPassword, signIn, signOut, getCurrentUser, confirmSignIn, confirmResetPassword } from 'aws-amplify/auth';
import { ToastContainer, ToastContentProps, toast } from 'react-toastify';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// import { useNavigate } from 'react-router-dom';
import { useNavigate, useLocation } from 'react-router-dom';

export const Navbar = () => {
    // Adding Javascript for popout modals over the icons. 
    // notifications javascript 
    const [notificationsOpen, setNotificationsOpen] = React.useState(false);
    const [toggleSidebar, setToggleSidebar] = useState(false);
    const [dashboardSelected, setDashboardSelected] = useState(false);
    const [newsSelected, setNewsSelected] = useState(false);
    const [threatsSelected, setThreatsSelected] = useState(false);
    const [analysisSelected, setAnalysisSelected] = useState(false);
    const [groupsSelected, setGroupsSelected] = useState(false);
    const [managedAttributionSelected, setManagedAttributionSelected] = useState(false);
    const navigate = useNavigate();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const location = useLocation();
    const [currentPage, setCurrentPage] = useState('');

    const toggleMobileMenu = () => {
        setMobileMenuOpen(prev => !prev);
    };

    // Navbar authentication redirect
    // useEffect(()=> {
    //     console.log("Logging in!");
    //     navigate('/login')
    // });


    useEffect(() => {
        // On page load, set current page based on path
        const path = location.pathname;
        if (path === '/') setCurrentPage('Intelligence Center');
        else if (path.startsWith('/analytics')) setCurrentPage('Analytics');
        else if (path.startsWith('/news')) setCurrentPage('News');
        else if (path.startsWith('/threatFeed')) setCurrentPage('Threat Feed');
        else if (path.startsWith('/assessments')) setCurrentPage('Assessments');
        else if (path.startsWith('/monitoring')) setCurrentPage('Monitoring');
        else if (path.startsWith('/managedAttribution')) setCurrentPage('Managed Attribution');
    }, [location.pathname]);

    const headerSelect = (page) => {
        setCurrentPage(page);

        switch (page) {
            case "Intelligence Center": navigate('/'); break;
            case "Analytics": navigate('/analytics'); break;
            case "News": navigate('/news'); break;
            case "Threat Feed": navigate('/threatFeed'); break;
            case "Assessments": navigate('/assessments'); break;
            case "Monitoring": navigate('/monitoring'); break;
            case "Managed Attribution": navigate('/managedAttribution'); break;
            default: break;
        }
    };


    const toggleNav = () => {
        setToggleSidebar(!toggleSidebar)
    }

    const toastSignedOutOfApp = () => (
        <div className="toastBody toastSuccess">
            <div className="icon"><CheckCircleIcon sx={{ fontSize: 20 }} /></div>
            <div className="message"><p>Signed Out of App</p></div>
        </div>
    );

    const notificationsFunc = () => {
        // console.log("notifications expanded");
        setNotificationsOpen(true);
    }
    const notificationsFuncClose = () => {
        // console.log("notifications");
        setNotificationsOpen(false);
    }

    // Messages javascript 
    const [messagesOpen, setMessagesOpen] = React.useState(false);

    const messagesFunc = () => {
        // console.log("notifications expanded");
        setMessagesOpen(true);
    }
    const messagesFuncClose = () => {
        // console.log("notifications");
        setMessagesOpen(false);
    }

    // Account javascript 
    const [accountModalOpen, setAccountModalOpen] = React.useState(false);

    const accountModalFunc = () => {
        // console.log("notifications expanded");
        setAccountModalOpen(true);
    }
    const accountModalFuncClose = () => {
        // console.log("notifications");
        setAccountModalOpen(false);
    }

    const handleSignOut = async () => {
        // console.log("Signing out of app")
        await signOut();
        toast(toastSignedOutOfApp)
        // console.log("Signed OUt")
        navigate("/login")
    }

    return (
        <div className="navbar mainHeader">
            {/* {toggleSidebar && (
        <div className="dropdown">
            <Sidebar/>
        </div>
         )} */}
            <ToastContainer
                position="top-center"
                hideProgressBar={false}
                closeOnClick={true}
                theme="dark"
            />
            <div className="doubleHorizontalSplit">
                <div className="horizontalAlign">
                    <div className="headerLogo" onClick={() => { headerSelect("Dashboard") }}>
                        <img src='/weathervaneLogo.svg' />
                    </div>
                </div>

                <div className="horizontalAlign">
                    <div className="navButtonDiv">
                        <div className={dashboardSelected ? "selectedNavButton" : "navButton"}>
                            <div className={currentPage === "Intelligence Center" ? "selectedNavButton" : "navButton"}>
                                <button onClick={() => headerSelect("Intelligence Center")}>Intelligence Center</button>
                            </div>
                        </div>

                        <div className={dashboardSelected ? "selectedNavButton" : "navButton"}>
                            <div className={currentPage === "Analytics" ? "selectedNavButton" : "navButton"}>
                                <button onClick={() => headerSelect("Analytics")}>Analytics</button>
                            </div>
                        </div>

                        <div className={newsSelected ? "selectedNavButton" : "navButton"}>
                            <div className={currentPage === "News" ? "selectedNavButton" : "navButton"}>
                                <button onClick={() => headerSelect("News")}>News</button>
                            </div>
                        </div>

                        <div className={threatsSelected ? "selectedNavButton" : "navButton"}>
                            <div className={currentPage === "Threat Feed" ? "selectedNavButton" : "navButton"}>
                                <button onClick={() => headerSelect("Threat Feed")}>Threat Feed</button>
                            </div>
                        </div>

                        <div className={analysisSelected ? "selectedNavButton" : "navButton"}>
                            <div className={currentPage === "Assessments" ? "selectedNavButton" : "navButton"}>
                                <button onClick={() => headerSelect("Assessments")}>Asessments</button>
                            </div>
                        </div>

                        <div className={groupsSelected ? "selectedNavButton" : "navButton"}>
                            <div className={currentPage === "Monitoring" ? "selectedNavButton" : "navButton"}>
                                <button onClick={() => headerSelect("Monitoring")}>Monitoring</button>
                            </div>
                        </div>

                        {/* <div className={managedAttributionSelected ? "selectedNavButton" : "navButton"}>
                            <div className={currentPage === "Managed Attribution" ? "selectedNavButton" : "navButton"}>
                                <button onClick={() => headerSelect("Managed Attribution")}>Managed Attribution</button>
                            </div>
                        </div>                     */}
                    </div>
                </div>

                <div className="horizontalAlign">
                    {/* <div className="notificationItem">
                    <MessageIcon className="icon" onClick={messagesFunc}/>
                    <div className="counter">1</div>
                </div>
                <div className="notificationItem">
                    <CircleNotificationsIcon className="icon" onClick={notificationsFunc}/>
                    <div className="counter">5</div>
                </div> */}
                    <div className="notificationItem">
                        <AccountCircleIcon className="icon" onClick={accountModalFunc} />
                    </div>
                    <div className="logout shortButton">
                        <button onClick={handleSignOut}>Log Out</button>
                    </div>
                    <div className="mobileMenuToggle" onClick={toggleMobileMenu}>
                        ☰
                    </div>
                </div>
            </div>
            {mobileMenuOpen && (
                <div className="mobileNavDropdown">

                    <button
                        onClick={() => {
                            headerSelect("Intelligence Center");
                            setMobileMenuOpen(false);
                        }}
                    >
                        Intelligence Center
                    </button>

                    <button
                        onClick={() => {
                            headerSelect("Analytics");
                            setMobileMenuOpen(false);
                        }}
                    >
                        Analytics
                    </button>

                    <button
                        onClick={() => {
                            headerSelect("News");
                            setMobileMenuOpen(false);
                        }}
                    >
                        News
                    </button>

                    <button
                        onClick={() => {
                            headerSelect("Threat Feed");
                            setMobileMenuOpen(false);
                        }}
                    >
                        Threat Feed
                    </button>

                    <button
                        onClick={() => {
                            headerSelect("Assessments");
                            setMobileMenuOpen(false);
                        }}
                    >
                        Assessments
                    </button>

                    <button
                        onClick={() => {
                            headerSelect("Monitoring");
                            setMobileMenuOpen(false);
                        }}
                    >
                        Monitoring
                    </button>

                    <button onClick={handleSignOut}>
                        Log Out
                    </button>

                </div>
            )}
            <div className="modals">
                <Notifications isOpen={notificationsOpen} onClose={notificationsFuncClose}>
                </Notifications>
                <Messages isOpen={messagesOpen} onClose={messagesFuncClose}>
                </Messages>
                <AccountModal isOpen={accountModalOpen} onClose={accountModalFuncClose}>
                </AccountModal>
            </div>
        </div>
    )
}
